var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.522 1.296a.5.5 0 01.956 0l.715 2.315a1.5 1.5 0 001.433 1.057h2.418a.5.5 0 01.303.897l-2.04 1.56a1.5 1.5 0 00-.523 1.634l.759 2.456a.5.5 0 01-.781.545L7.91 10.346a1.5 1.5 0 00-1.822 0L4.24 11.76a.5.5 0 01-.782-.545l.759-2.456a1.5 1.5 0 00-.523-1.635l-2.04-1.559a.5.5 0 01.303-.897h2.418a1.5 1.5 0 001.433-1.057l.715-2.315z",
    fill: "#fff",
    stroke: "#707175"
  })));
}
export default SvgIsFavorite;